import moment from 'moment'
import lodash from 'lodash'
import type { ActivityOptions, ActivityBtn } from './types'
import { EnumActivityBtnType } from '@xt/client/enums/activity/index'
import { getServerTime } from '@xt/client/experimental/server-time'
import { $service } from '@xt/client/experimental/request/service'
import { EnumApiCourse } from '@xt/client/api/course'

// 获取已经买过的课程id
export const getCourseListHasbuy = async (): Promise<number[]> => {
  const [hasbuyIdsError, hasbuyIds] = await $service<Array<number>>({
    url: EnumApiCourse.CourseListHasbuy
  })

  if (hasbuyIdsError) return []

  return hasbuyIds
}

// 获取课程按钮配置
export const mapCourseButton = (data: ActivityOptions): ActivityBtn => {
  const now = getServerTime('moment')
  const { id, convertEndTime, signupStartTime, signupEndTime, startTime, endTime, courses, hasBuyIds, isLogin } = data

  const convertEndTimeMoment = moment(convertEndTime)
  const signupStartTimeMoment = moment(signupStartTime)
  const signupEndTimeMoment = moment(signupEndTime)
  const startTimeMoment = moment(startTime)
  const endTimeMoment = moment(endTime)

  const allCourseHasbuy = lodash.includes(hasBuyIds, id)
  // 未购买，且报名时间已结束
  const hasEndCourse = courses.some(v => {
    return !lodash.includes(hasBuyIds, v.id) && now.isAfter(moment(v.signupEndTime))
  })
  // 是否有购买
  const hasPer = !!courses.filter(v => lodash.includes(hasBuyIds, v.id)).length

  // 当前时间大于转报结束时间且课程结束则 已结课
  if (now.isAfter(convertEndTimeMoment) && now.isAfter(endTimeMoment)) {
    return {
      type: EnumActivityBtnType.ClassEnd,
      label: '已结课'
    }
  }

  if (allCourseHasbuy && now.isAfter(signupEndTimeMoment) && now.isBefore(convertEndTimeMoment)) {
    return {
      type: EnumActivityBtnType.GoClass,
      label: '已报名,去上课',
      countdown: {
        endTime: convertEndTime
      }
    }
  }

  // 当前时间大于转报结束时间且大于报名结束时间
  if (now.isAfter(convertEndTimeMoment) && now.isAfter(signupEndTimeMoment)) {
    // 且课程已开启则 开课中
    if (now.isAfter(startTimeMoment)) {
      return {
        type: EnumActivityBtnType.InClass,
        label: '开课中'
      }
    } else {
      return {
        type: EnumActivityBtnType.ClassEnd,
        label: '报名结束'
      }
    }
  }

  // 转报全阶
  if (now.isAfter(signupEndTimeMoment) && now.isBefore(convertEndTimeMoment)) {
    if ((!hasEndCourse && hasPer) || !isLogin)
      return {
        type: EnumActivityBtnType.Convert,
        label: '转报全阶',
        countdown: {
          endTime: convertEndTime
        }
      }

    return {
      type: EnumActivityBtnType.NoConvert,
      label: '不满足转报全阶要求',
      countdown: {
        endTime: convertEndTime
      }
    }
  }

  if (now.isAfter(signupStartTimeMoment) && now.isBefore(signupEndTimeMoment)) {
    if (!hasEndCourse && hasPer)
      return {
        type: EnumActivityBtnType.Convert,
        label: '转报全阶',
        countdown: {
          endTime: signupEndTime
        }
      }

    return {
      type: EnumActivityBtnType.Signup,
      label: '我要报名',
      countdown: {
        endTime: signupEndTime
      }
    }
  }

  return {
    type: EnumActivityBtnType.NotStarted,
    label: '即将报名',
    time: `时间${signupEndTimeMoment.format('YYYY年MM月DD日')}`
  }
}

// 格式化倒计时数据
export const formatEndTimeCountdown = (endTimestamp: number): string => {
  const now = getServerTime('moment')
  const end = moment(endTimestamp)

  if (now.isAfter(end)) return ''

  const duration = moment.duration(end.diff(now))
  const hours = Math.floor(duration.asHours())
  const days = Math.floor(duration.asDays())

  if (hours > 24) {
    return `剩余${days}天`
  } else {
    return `剩余${hours}时${duration.minutes()}分${duration.seconds()}秒`
  }
}
